// Grouped client for LeadType operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { LeadType } from '../models/LeadType';
import { FilterLeadTypeRequest } from '../models/FilterLeadTypeRequest';
import { DataviewLeadTypeResponse } from '../models/DataviewLeadTypeResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { LeadTypeSerializer } from '../serializers/LeadTypeSerializer';
import { FilterLeadTypeRequestSerializer } from '../serializers/FilterLeadTypeRequestSerializer';
import { DataviewLeadTypeResponseSerializer } from '../serializers/DataviewLeadTypeResponseSerializer';

/**
 * HTTP client for LeadType operations
 *
 * Client for LeadType operations
 */
export class LeadTypeClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForLeadType(formName: string, objectId: string, name?: string | null, description?: string | null, id?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/LeadType({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeLeadType(formName: string, name?: string | null, description?: string | null, id?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/LeadType/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    if (id !== undefined) {
      queryParams.append('_id', String(id));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterLeadType(request?: FilterLeadTypeRequest | null, options?: { headers?: Record<string, string> }): Promise<LeadType[]> {
    const path = '/app/api/Object/LeadType/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadTypeRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadTypeSerializer.fromObject(item));
  }

  async recentLeadType(request?: FilterLeadTypeRequest | null, options?: { headers?: Record<string, string> }): Promise<LeadType[]> {
    const path = '/app/api/Object/LeadType/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadTypeRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => LeadTypeSerializer.fromObject(item));
  }

  async dataViewLeadType(request?: FilterLeadTypeRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewLeadTypeResponse> {
    const path = '/app/api/Object/LeadType/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterLeadTypeRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewLeadTypeResponseSerializer.fromObject(data);
  }

}
